import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Layers, Check } from "lucide-react";

// Item 79 follow-up: quick-switch a master filter's interaction profile from the toolbar.
export function profileMasters(widgets) {
  return (widgets || []).filter((w) => !w.hidden && (w.config?.interaction_profiles || []).length > 1);
}

// Config patch that activates a saved profile (same shape the InteractionsPanel persists).
export function applyProfilePatch(w, profileId) {
  const profs = w?.config?.interaction_profiles || [];
  const prof = profs.find((p) => p.id === profileId);
  if (!prof) return null;
  return {
    interactions: { ...(prof.interactions || {}) },
    field_mappings: prof.mapping_mode === "custom"
      ? (prof.mappings || []).filter((m) => m.source_col && m.target_dataset && m.target_col)
      : [],
    active_profile: profileId,
  };
}

export function ProfileSwitcher({ widgets, onApply }) {
  const masters = profileMasters(widgets);
  if (!masters.length || !onApply) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid="profile-switcher-btn" variant="outline" size="sm" className="bg-[color:var(--surface)] h-9" title="Switch interaction profiles">
          <Layers className="w-4 h-4 mr-1 text-[color:var(--brand-ocean)]" />Profiles
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        {masters.map((w, mi) => {
          const profs = w.config.interaction_profiles || [];
          const activeId = profs.some((p) => p.id === w.config.active_profile) ? w.config.active_profile : profs[0]?.id;
          return (
            <React.Fragment key={w.id}>
              {mi > 0 && <DropdownMenuSeparator />}
              <DropdownMenuLabel className="text-[10px] uppercase tracking-wide text-[color:var(--ink-3)]">{w.title || "Filter"}</DropdownMenuLabel>
              {profs.map((p) => (
                <DropdownMenuItem key={p.id} data-testid={`profile-option-${w.id}-${p.id}`} onClick={() => onApply(w.id, p.id)}>
                  <Check className={"w-4 h-4 mr-2 " + (activeId === p.id ? "text-[color:var(--brand-mint)]" : "opacity-0")} />
                  {p.name || p.id}
                </DropdownMenuItem>
              ))}
            </React.Fragment>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
